export var LoginPageNames;
(function (LoginPageNames) {
    LoginPageNames["Default"] = "default";
    LoginPageNames["ForgotPassword"] = "forgot_password";
    LoginPageNames["Consent"] = "TermsAndConditions";
    LoginPageNames["OrganizationEmailLogin"] = "OrganizationEmailLogin";
})(LoginPageNames || (LoginPageNames = {}));
export const routes = [
    {
        path: '/',
        component: () => import(
        /*webpackChunkName: "LoginMainContent"*/ '@/vue/login/components/LoginMainContent.vue'),
        name: LoginPageNames.Default,
    },
    {
        path: '/forgot_password',
        component: () => import(/*webpackChunkName: "ForgotPassword"*/ '@/vue/login/components/ForgotPassword.vue'),
        name: LoginPageNames.ForgotPassword,
    },
    {
        path: '/terms_and_conditions',
        component: () => import(
        /*webpackChunkName: "TermsAndConditions"*/ '@/vue/login/components/TermsAndConditions.vue'),
        name: LoginPageNames.Consent,
    },
    {
        path: '/organization_login',
        component: () => import(
        /*webpackChunkName: "TermsAndConditions"*/ '@/vue/login/components/single_sign_on/OrganizationEmailLogin.vue'),
        name: LoginPageNames.OrganizationEmailLogin,
    },
];
